import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories, type Category } from '@/mocks/categoryData';

const mangaCovers: string[] = [
  'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20artistic%20book%20cover%20with%20flowing%20shapes%2C%20minimalist%20design%2C%20soft%20gradients%2C%20elegant%20textures%2C%20coral%20and%20cream%20color%20palette%2C%20clean%20modern%20aesthetic%2C%20no%20text%20or%20characters&width=600&height=800&seq=manga-cover-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20abstract%20cover%20design%20with%20organic%20flowing%20lines%2C%20soft%20gradients%2C%20elegant%20amber%20and%20cream%20textures%2C%20modern%20artistic%20style%2C%20no%20text&width=600&height=800&seq=manga-cover-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Warm%20abstract%20cover%20with%20geometric%20flowing%20shapes%2C%20layered%20textures%2C%20coral%20and%20sand%20gradients%2C%20minimalist%20composition%2C%20elegant%20design%2C%20no%20text&width=600&height=800&seq=manga-cover-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20cover%20with%20smooth%20flowing%20gradients%2C%20soft%20metallic%20textures%2C%20coral%20and%20cream%20palette%2C%20minimalist%20modern%20design%2C%20no%20text&width=600&height=800&seq=manga-cover-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Warm%20ink%20wash%20inspired%20abstract%20cover%20with%20flowing%20textures%2C%20soft%20gradients%2C%20coral%20and%20gold%20accents%2C%20minimalist%20artistic%20design%2C%20no%20text&width=600&height=800&seq=manga-cover-05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Abstract%20collage%20style%20warm%20toned%20cover%20with%20layered%20shapes%2C%20soft%20textured%20gradients%2C%20coral%20and%20cream%20aesthetic%2C%20modern%20design%2C%20no%20text&width=600&height=800&seq=manga-cover-06&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Deep%20warm%20abstract%20cover%20with%20continuous%20flowing%20lines%2C%20rich%20layered%20textures%2C%20coral%20and%20sand%20palette%2C%20elegant%20modern%20design%2C%20no%20text&width=600&height=800&seq=manga-cover-07&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Vibrant%20warm%20abstract%20cover%20with%20dynamic%20flowing%20shapes%2C%20bold%20soft%20gradients%2C%20coral%20and%20amber%20highlights%2C%20energetic%20modern%20design%2C%20no%20text&width=600&height=800&seq=manga-cover-08&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20cover%20with%20elegant%20curved%20shapes%2C%20soft%20gradient%20washes%2C%20coral%20and%20cream%20textures%2C%20minimalist%20composition%2C%20no%20text&width=600&height=800&seq=manga-cover-09&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Modern%20warm%20abstract%20cover%20with%20flowing%20organic%20forms%2C%20layered%20gradients%2C%20coral%20and%20sand%20palette%2C%20elegant%20minimalist%20design%2C%20no%20text&width=600&height=800&seq=manga-cover-10&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Artistic%20warm%20toned%20abstract%20cover%20with%20watercolor%20inspired%20textures%2C%20soft%20flowing%20gradients%2C%20coral%20and%20cream%20aesthetic%2C%20no%20text&width=600&height=800&seq=manga-cover-11&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Warm%20abstract%20cover%20with%20bold%20geometric%20shapes%2C%20soft%20layered%20textures%2C%20coral%20and%20amber%20gradients%2C%20modern%20minimalist%20design%2C%20no%20text&width=600&height=800&seq=manga-cover-12&orientation=portrait',
];

const mangaTitles: string[] = [
  '精品漫画作品选集', '热门连载大全', '经典收藏系列', '年度推荐佳作',
  '新番速递合集', '独家精品资源', '高分必看推荐', '人气爆款连载',
  '限定特典收录', '殿堂级收藏品', '热门话题作品', '编辑精选推荐',
];

const mangaAuthors: string[] = [
  '山下太郎', '金秀贤', 'Alex Morgan', 'CG工坊',
  '墨韵社', '短篇工厂', '长篇连载组', '排行数据',
  '田中花子', 'Park Minjun', 'Elena Rossi', 'RenderLab',
];

const mangaChapters: number[] = [45, 128, 89, 234, 16, 72, 156, 198, 33, 67, 112, 201];
const mangaRatings: string[] = ['4.8', '4.6', '4.9', '4.5', '4.3', '4.7', '4.8', '4.4', '4.6', '4.9', '4.5', '4.7'];

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState<Category | null>(null);

  useEffect(() => {
    const found = categories.find((c) => c.slug === slug);
    setActiveCategory(found || categories[0]);
  }, [slug]);

  if (!activeCategory) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-16">
        <div className="text-center">
          <i className="ri-emotion-sad-line text-4xl text-foreground-300"></i>
          <p className="mt-3 text-foreground-500">分类未找到</p>
          <Link to="/" className="mt-4 inline-block text-primary-500 text-sm hover:underline">
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${activeCategory.name} - 禁漫天堂`,
    description: activeCategory.description,
    url: `https://jmtthub.com/category/${activeCategory.slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '禁漫天堂',
      url: 'https://jmtthub.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      <div className="min-h-screen pt-16">
        <div className="w-full px-4 md:px-6 pt-6 pb-4">
          <div className="max-w-6xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '分类导航', path: '/category/riman' },
                { label: activeCategory.name },
              ]}
            />
          </div>
        </div>

        {/* Category Header */}
        <section className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-6xl mx-auto">
            <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-10">
              <div className="flex flex-col lg:flex-row gap-8 items-start">
                <div className="flex-shrink-0">
                  <div className="w-24 h-24 md:w-28 md:h-28 flex items-center justify-center rounded-2xl bg-primary-100">
                    <i className="ri-stack-line text-4xl text-primary-500"></i>
                  </div>
                </div>
                <div className="flex-1">
                  <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                    {activeCategory.name}
                  </h1>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                    {activeCategory.description}
                  </p>
                  <div className="flex flex-wrap items-center gap-2">
                    {activeCategory.tags.map((tag: string) => (
                      <span
                        key={tag}
                        className="text-xs px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 font-medium"
                      >
                        {tag}
                      </span>
                    ))}
                    <span className="text-xs text-foreground-400 ml-2">
                      共 {activeCategory.count.toLocaleString()} 部作品
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Category Tabs */}
        <section className="w-full px-4 md:px-6 pb-4">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center gap-2 overflow-x-auto pb-2 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                    activeCategory.slug === cat.slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-50 text-foreground-600 border border-background-200/70 hover:border-primary-300 hover:text-primary-500'
                  }`}
                >
                  {cat.name}
                  <span className={`text-xs ${activeCategory.slug === cat.slug ? 'text-white/70' : 'text-foreground-400'}`}>
                    {cat.count.toLocaleString()}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Manga Grid */}
        <section className="w-full px-4 md:px-6 py-6 md:py-10">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {mangaCovers.map((cover, i) => (
                <div
                  key={i}
                  className="group bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
                >
                  <div className="aspect-[3/4] overflow-hidden">
                    <img
                      src={cover}
                      alt={mangaTitles[i]}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-3">
                    <h3 className="text-xs font-medium text-foreground-800 line-clamp-2 mb-1.5 group-hover:text-primary-500 transition-colors">
                      {mangaTitles[i]}
                    </h3>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-foreground-500">{mangaAuthors[i]}</span>
                      <div className="flex items-center gap-1">
                        <i className="ri-star-fill text-[10px] text-accent-500"></i>
                        <span className="text-xs text-foreground-400">{mangaRatings[i]}</span>
                      </div>
                    </div>
                    <div className="mt-1.5 text-[10px] text-foreground-400">
                      更新至 {mangaChapters[i]} 话
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {activeCategory.count > 12 && (
              <div className="mt-10 text-center">
                <p className="text-sm text-foreground-500 mb-3">
                  显示 12 / {activeCategory.count.toLocaleString()} 部作品
                </p>
                <button className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm font-medium text-foreground-600 hover:border-primary-300 hover:text-primary-500 transition-all cursor-pointer whitespace-nowrap">
                  <i className="ri-arrow-down-line"></i>
                  加载更多
                </button>
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  );
}